import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type FormFeedbackComponentProps = {};

export type FormFeedbackProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, FormFeedbackComponentProps, "div">;

const FormFeedback = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: FormFeedbackProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);

    return (
        <Tag
            {...attributes}
            className={cn(
                "tw:block tw:mt-1 tw:text-sm tw:text-danger",
                className
            )}
        />
    );
};

export { FormFeedback };
